import Alpine from 'alpinejs';

Alpine.store('app', {
    isMobile: true,
    isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
    isIE: Boolean(window.document.documentMode),
    init() {
        this.updateIsMobile();
        window.addEventListener('resize', () => {
            this.updateIsMobile();
        }, false);
    },
    updateIsMobile() {
        this.isMobile = (Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 1024);
    },
})